import { render, staticRenderFns } from "./PhysicalMedia.vue?vue&type=template&id=b707731c&"
import script from "./PhysicalMedia.vue?vue&type=script&lang=js&"
export * from "./PhysicalMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports